export const API_URL = 'https://api.chat.needtech.cc/graphql'
export const API_URL_WS = 'wss://api.chat.needtech.cc/graphql'

export const COMPANY_SLUG = 'polvo'

export const LOCAL_STORAGE_CHAT_ID = '@publicChat@chatId'
export const LOCAL_STORAGE_CHAT_MESSAGES = '@publicChat@chatMessages'
